import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

interface ISegmentData {
  id: number,
  code_segment: string,
  code_description: string,
  create_at: string,
  create_by: string,
  update_at: string,
  update_by: string
}
export interface IGetSegmentsResponse {
  listSegment: ISegmentData[]
}

const url = "/v1/segment";

export const getSegments = async (): Promise<IGetSegmentsResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
  });

  return data;
};
